import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentService } from 'src/app/_services/document.services';
import { AppConfig } from 'src/assets/config/config/app-config';
import { MatDrawerContainer } from '@angular/material/sidenav';

@Component({
  selector: 'app-audit-document',
  templateUrl: './audit-document.component.html',
  styleUrls: ['./audit-document.component.scss']
})
export class AuditDocumentComponent implements OnInit {

  @Output() openHistory = new EventEmitter<boolean>()
  @Input() documentId: string;

  tableDataSource: MatTableDataSource<any>;
  displayedColumns = ["event", "performer", "performedOn"];
  selectedHeader: number;
  enableWorkflow: boolean = this.config.getConfig("enableWorkflow")

  sort;
  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.tableDataSource.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.tableDataSource.paginator = this.paginator;
    }
  }

  constructor(
    private documentService: DocumentService,
    private config: AppConfig
  ) { }

  ngOnInit() {
      this.fetchAuditDetails()
  }

  fetchAuditDetails() {
    this.documentService.getDocumentAudit(this.documentId).subscribe(details => {
      this.tableDataSource = new MatTableDataSource(details)
      this.tableDataSource.sort = this.sort
          this.tableDataSource.paginator = this.paginator
          this.tableDataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'event': return <string>item.auditevent;
              case 'performer': return <string>item.performer.priority_user;
              case 'performedOn': return new Date(item.auditdatetime);
              default: return item[property];
            }
          };
    })
  }

  back() {
    this.openHistory.emit(false)
  }
}
